<template>
  <div class="condition-item">
    <normal-select
      v-if="!_.isEmpty(keyList)"
      :disabled="disabled"
      :select-list="keyList"
      :selected-item="value.key"
      :size="size"
      @update:selectedItem="keySelected"
      filterable
    ></normal-select>
    <tree-select
      v-else
      v-model="value.key"
      @input="keySelected"
      :disabled="disabled"
      :group-list="simpleWorkflowVarList"
    ></tree-select>
    <div class="compare-row">
      <normal-select
        :disabled="disabled"
        :select-list="methodList"
        :selectedItem.sync="value.compareMethod"
        :size="size"
        @update:selectedItem="clearValue"
        class="compare-method"
      ></normal-select>

      <compare-value
        :control="currentControl"
        :compare-method="value.compareMethod"
        v-model="value.varItems"
        :disabled="disabled"
        :dropdown-var-list="dropdownVarList"
        :var-label-map="varLabelMap"
        :from="from"
        :app-roles="appRoles"
        :company-roles="companyRoles"
        :sheet-id="sheetId"
        :size="size"
      ></compare-value>
    </div>
  </div>
  <!-- 条件选择器 End -->
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import CompareValue from "@/components/UIComponents/ConditionList/CompareValue"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { filterTreeVarGroup, getCompareMethods } from "@/utils/workFlow"

export default {
  name: "condition-item",
  components: { NormalSelect, CompareValue, TreeSelect },
  props: {
    value: {
      type: Object,
      default: () => ({
        key: "", // 控件ID
        type: "", // 控件类型
        compareMethod: "", // 比较方法
        varItems: [] // 值 [{value:'',var:true}]
      })
    },
    disabled: { type: Boolean, default: false },
    controlMap: Object,
    keyList: Array,
    relySheetVarList: Array,
    simpleWorkflowVarList: Array,
    workflowVarControlMap: Object,
    simpleQueryConditionList: Array,
    varLabelMap: Object,
    from: String,
    size: {
      type: String,
      default: null // small normal
    },
    appRoles: Array,
    companyRoles: Array,
    sheetId: String
  },
  data() {
    return {
      includeSubDepartment: false
    }
  },
  computed: {
    currentControl() {
      if (["workflow_gateway", "validate_rule"].includes(this.from)) {
        return this.workflowVarControlMap?.[this.value.key] || {}
      } else {
        return this.controlMap?.[this.value.key] || {}
      }
    },
    methodList() {
      let type = this.currentControl._type
      if (!type) return
      let { compareMethods } = getCompareMethods({ type, from: this.from })
      return compareMethods.map(i => ({
        label: this.getCompareName(type, i),
        value: i
      }))
    },
    varList() {
      let result = []
      switch (this.from) {
        case "board_query":
          result = this.simpleQueryConditionList
          break
        case "sheet_backend":
        case "chart_control":
        case "sheet_frontend":
          result = this.relySheetVarList
          break
        default:
          result = this.simpleWorkflowVarList
          break
      }
      return ["string", "number", "time"].includes(this.currentControl._dataType)
        ? result
        : result.filter(item => !item.label?.includes("自己"))
    },
    dropdownVarList() {
      if (this.from === "board_query") {
        if (this.varList.length === 1)
          return this.currentControl._dataType === "string" ? this.varList : []
        else if (this.varList.length === 2) {
          let filterList = this.varList.map((item, index) => {
            if (index === 0) return item
            return {
              label: item.label,
              options: item.options.filter(option => {
                let varControl = option.control || {}
                let control = this.currentControl
                return this.getResult(varControl, control)
              })
            }
          })
          return this.currentControl._dataType === "string" ? filterList : filterList.slice(1)
        } else {
          return []
        }
      } else
        return filterTreeVarGroup({
          varGroup: this.varList,
          filterFunc: option => {
            let varControl = option.control || {}
            let control = this.currentControl
            return this.getResult(varControl, control)
          }
        })
    }
  },
  methods: {
    getCompareName(type, i) {
      if (type === "check") return i === "真" ? "选中" : i === "假" ? "未选中" : i
      if (type === "verify") return i === "为空" ? "撤回" : i
      return i
    },
    getResult(varControl, control) {
      if ("string" === control._dataType) {
        return varControl._dataType === "string" || varControl._type === "option"
      }
      if ("number" === control._dataType) {
        return varControl._dataType === "number"
      }
      if (control._type === "ref") {
        return (
          varControl._type === "ref" &&
          (varControl.refSheetId === control.refSheetId || !varControl.refSheetId) // refSheetId为空,代表是代码块输出的
        )
      }
      if (control._type === "rich") {
        return varControl._dataType === "string"
      }
      if (control._dataType === "bool") {
        return varControl._dataType === "bool"
      }
      return varControl._type === control._type
    },
    keySelected(val) {
      this.value.key = val
      this.value.type = this.currentControl._type
      this.value.compareMethod = null
      this.clearValue()
    },
    clearValue() {
      this.value.varItems = []
      this.value.value = null // 为了防止编辑历史的时候,老数据格式不合法
    }
  }
}
</script>

<style lang="scss" scoped>
.condition-item {
  .compare-row {
    display: flex;
    align-items: flex-start;
    margin-top: 4px;
    .compare-method {
      width: 120px;
      margin-right: 4px;
    }
    .compare-value {
      flex: 1;
    }
  }
}
</style>
